import { AxiosResponse } from "axios";
import useAxios from "hooks/useAxios";

// Forma persistida de cada widget do dashboard (posicao no grid + configuracao).
// widgetData fica generico de proposito: tipar com WidgetConfig criaria ciclo de import.
export type PersistedWidget = {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  type?: string;
  widgetData?: Record<string, unknown>;
};

type UseFleetDashboardAPIType = {
  getWidgetData: (
    customerId: string,
    username: string
  ) => Promise<PersistedWidget[]>;
  setWidgetData: (
    customerId: string,
    username: string,
    widgetData: PersistedWidget[]
  ) => Promise<unknown>;
};

export const SERVER_PAGE_SIZE = 100;

const useFleetDashboardAPI = (): UseFleetDashboardAPIType => {
  const API = useAxios();

  const getWidgetData = async (
    customerId: string,
    username: string
  ): Promise<PersistedWidget[]> => {
    const response: AxiosResponse<PersistedWidget[]> = await API.instance.get(
      "widget",
      {
        params: {
          ["customer_id"]: customerId,
          username: username
        }
      }
    );

    return response.data;
  };

  const setWidgetData = async (
    customerId: string,
    username: string,
    widgetData: PersistedWidget[]
  ): Promise<unknown> => {
    const response: AxiosResponse<unknown> = await API.instance.post(
      "widget/set",
      {
        customer_id: customerId,
        username: username,
        widget_data: widgetData
      }
    );

    return response.data;
  };

  return {
    getWidgetData,
    setWidgetData
  };
};
export default useFleetDashboardAPI;
